import * as React from "react"
import type { SVGProps } from "react"
const SvgBetaBeaker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.68 16.55q.45.95 1.5.95h11.63q1.06 0 1.51-.95t-.22-1.76l-4.6-5.62v-5h.82a.8.8 0 0 0 .6-.24.8.8 0 0 0 .23-.6.8.8 0 0 0-.24-.59.8.8 0 0 0-.59-.24H6.68a.8.8 0 0 0-.6.24.8.8 0 0 0-.23.6q0 .35.24.59a.8.8 0 0 0 .59.24h.83v5L2.9 14.79a1.55 1.55 0 0 0-.22 1.76m4.24-4.05-2.73 3.33H15.8l-1.36-1.66h-3A2.9 2.9 0 0 1 9.13 13a1.4 1.4 0 0 0-.45-.36 1 1 0 0 0-.55-.14zm1.36-1.66.89-1.09V4.17h1.66v5.58l2.25 2.75h-1.63q-.29 0-.56-.12-.27-.13-.43-.38a3 3 0 0 0-2.18-1.16"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgBetaBeaker
